import { Paper, type PaperProps } from '@mui/material';
import { UW_PANEL_GAP, useIsUwView } from '../components/uwTileSpacing';

const SectionCard = (props: SectionCardProps) => {
  // The agency quote views render these cards too; they keep the original
  // shadow and spacing, and only the underwriter view gets the lighter set.
  const isUwView = useIsUwView();

  return (
    <Paper
      elevation={isUwView ? 2 : 5}
      className="contrast-text"
      sx={{
        marginBottom: isUwView ? UW_PANEL_GAP : '2rem',
        border: (theme) => {
          if (theme.palette.mode === 'light') {
            return 'none';
          }
          return `1.75px solid ${theme.palette.divider}`;
        },
      }}
      {...props}
    >
      {props.children}
    </Paper>
  );
};

export default SectionCard;

type SectionCardProps = {
  children: React.ReactNode;
} & PaperProps;
